import { getKeys, PartialRecord } from "@base/util/TypeUtil";
import { AlternativeMap } from "@biz/definitions/ArticleChooser";
import { MaterialType } from "@biz/definitions/SunSailDefinitions";

type IMaterialMapItem = PartialRecord<MaterialType, string>;
export type IMaterialMap = Record<string, IMaterialMapItem>;

export class MaterialMap {
  static alu(articleId: string): IMaterialMapItem {
    return {
      "Alu": articleId,
      "Alu_Black": articleId,
      "AluWood": articleId
    }
  }
  static steel(articleId: string): IMaterialMapItem {
    return {
      "Steel": articleId,
      "Steel_V4A": articleId,
    }
  }
  static push(articles: string[], articleGroup: IMaterialMapItem, material: MaterialType | undefined): void {
    if (material) {
      const article = articleGroup[material];
      if (article)
        articles.push(article);
    }
  }

  static calcAlternativeMap(materialMap: IMaterialMap): AlternativeMap {
    const alternativeMap: Record<string, string[]> = {}
    for (const itemId of getKeys(materialMap)) {
      const itemGroup = materialMap[itemId];
      const articles = Object.values(itemGroup);
      for (const articleId of articles) {
        let a = alternativeMap[articleId];
        if (!a)
          a = [];
        a.push(...articles)
        alternativeMap[articleId] = a;
      }
    }
    return alternativeMap;
  }

  static includes(items: IMaterialMapItem | IMaterialMapItem[], articleNumber: string): boolean {
    if (!Array.isArray(items)) {
      items = [items];
    }
    for (const item of items) {
      if (Object.values(item).includes(articleNumber))
        return true;
    }
    return false;
  }
}
export const heightChangeMaterialMap = {
  pulley: { ...MaterialMap.alu("00E13001874"), ...MaterialMap.steel("00E13001875") }, // Soliday Höhenverstellung für System C/CS // was 71006A001 https://plaspack.atlassian.net/browse/APP22-470
  c12r40Plus: { ...MaterialMap.alu("00E13001925"), ...MaterialMap.steel("00E13001926"), "Droppole": "00E13001927", "Droppole_Black": "00E13001975" },
  c12r40: {
    ...MaterialMap.alu("00E13000974"), ...MaterialMap.steel("00E13000975"), "Droppole": "00E13000976", "Droppole_Black": "00E13001973"
  },
  e12r40: {
    ...MaterialMap.alu("00E13001056"), ...MaterialMap.steel("00E13001057"), "Droppole": "00E13001058", "Droppole_Black": "00E13001974"
  },
  customWinch: { "Droppole": "00E13000208", "Droppole_Black": "00E13000988" },
  sandyPatent: { ...MaterialMap.alu("60003A003"), "Iron48": "60003A001" },
  sandyWire: { "Iron48": "60003A002" }
} satisfies IMaterialMap;

export const heightChangeAlternativeMap = MaterialMap.calcAlternativeMap(heightChangeMaterialMap);